module.exports = __webpack_public_path__ + "img/snapshots.2b13eadf.svg";